import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BadgeComponent } from '../../../badge/badge.component';
import {
  ItemMenuComponent,
  ItemMenuStyle,
} from '../../../item-menu/item-menu.component';
import { MatIcon } from '@angular/material/icon';
import { TabItem } from '../../tab-menu.model';

@Component({
  selector: 'twc-tab-menu-item',
  imports: [BadgeComponent, ItemMenuComponent, MatIcon],
  templateUrl: './tab-menu-item.component.html',
  styleUrl: './tab-menu-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabMenuItemComponent<T = unknown> {
  item = input.required<TabItem>();
  menuItemArgument = input<T>();

  protected readonly ItemMenuStyle = ItemMenuStyle;
}
